// extracted by mini-css-extract-plugin
module.exports = {"interview-list":"index_interview-list__1lkkR","interview-list__item":"index_interview-list__item__3mDb4"};